module.exports = __webpack_public_path__ + "img/img_phone.a2b2582e.png";